import { Check } from 'lucide-react';

/** Compact verified/unverified marker shared by both phone lines. */
export const PhoneVerBadge = ({ verified }: { verified: boolean }) =>
  verified ? (
    <span className="inline-flex items-center gap-0.5 text-xs text-emerald-600">
      <Check className="h-3 w-3" />
      verified
    </span>
  ) : (
    <span className="text-xs text-amber-600">(unverified)</span>
  );
